import { isEvmBlockchain } from 'rango-types';
import { defineChain } from 'viem';
export function convertMetaChainsToPrivySupportedChains(blockchains) {
    return blockchains
        .filter((blockchain) => isEvmBlockchain(blockchain))
        .map((blockchain) => {
        const { name, chainId, info } = blockchain;
        const { rpcUrls, nativeCurrency, blockExplorerUrls } = info;
        const [defaultBlockExplorerUrl] = blockExplorerUrls;
        const rpcUrlsMap = {
            default: { http: rpcUrls },
        };
        return defineChain({
            id: Number(chainId),
            name,
            nativeCurrency,
            blockExplorers: {
                default: {
                    name: defaultBlockExplorerUrl,
                    url: defaultBlockExplorerUrl,
                },
            },
            rpcUrls: rpcUrlsMap,
        });
    });
}
